"use client";
import "./homeManifesto.css";
import { motion } from "framer-motion";
import { fadeUp } from "@lib/motion";
import RichText from "@components/text/RichText/RichText";

export default function HomeManifesto() {
  return (
    <motion.div id="home-manifesto" className="home-manifesto" {...fadeUp()}>
      <p className="home-manifesto-quote">
        <RichText translationKey="home.manifesto.text" />
      </p>
    </motion.div>
  );
}
